export const contentTableConfig = {
  title: '不允许拉群客户群组列表',
  propList: [
    {prop: 'name', label: '群名', minWidth: '80'},
    {prop: 'owner', label: ' 群主工作账号', minWidth: '80'},
    {prop: 'usedBy', label: '群主姓名', minWidth: '80'},
    {prop: 'custName', label: '客户名称', minWidth: '80'},
    {prop: 'unionid', label: '客户unionid', minWidth: '80'},
    {prop: 'thirdParty', label: '所属三方', minWidth: '80'},
    {prop: 'sourceLabel', label: '来源渠道', minWidth: '80'},
    {prop: 'joinTime', label: '拉群时间', minWidth: '80'},
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
